module.exports = __webpack_public_path__ + "img/158.5dc194f8.jpg";